import { render, staticRenderFns } from "./ProductsInStockLocations.vue?vue&type=template&id=5c76304b&scoped=true"
import script from "./ProductsInStockLocations.vue?vue&type=script&lang=js"
export * from "./ProductsInStockLocations.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockLocations.vue?vue&type=style&index=0&id=5c76304b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76304b",
  null
  
)

export default component.exports